export enum ApiStatusEnum {
	SUCCESS = 'success',
	PENDING = 'pending',
	FAILED = 'failed',
}

export enum AccountStatusEnum {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	SUSPENDED = 'suspended',
	BANNED = 'banned',
}

export enum ApiTypeEnum {
	BVN_MATCH = 'bvn_match',
	NIN_MATCH = 'nin_match',
	BVN_MINI = 'bvn_mini',
	BVN = 'bvn',
	INTERNATIONAL_PASSPORT_MINI = 'international_passport_mini',
	INTERNATIONAL_PASSPORT = 'international_passport',
	NIN_MINI = 'nin_mini',
	NIN = 'nin',
	NIN_WITH_PHONE_MINI = 'nin_with_phone_mini',
	NIN_WITH_PHONE = 'nin_with_phone',
	NIN_WITH_SLIP_MINI = 'nin_with_slip_mini',
	NIN_WITH_SLIP = 'nin_with_slip',
	VIRTUAL_NIN_MINI = 'virtual_nin_mini',
	VIRTUAL_NIN = 'virtual_nin',
	VOTERS_CARD_MINI = 'voters_card_mini',
	VOTERS_CARD = 'voters_card',
	DRIVERS_LICENSE_MINI = 'drivers_license_mini',
	DRIVERS_LICENSE = 'drivers_license',
	PASSPORT_PHOTOGRAPH = 'passport_photograph',
	LIKENESS = 'likeness',
	LIKENESS_BVN = 'likeness_bvn',
	LIKENESS_INTERNATIONAL_PASSPORT = 'likeness_international_passport',
	LIKENESS_NIN = 'likeness_nin',
	LIKENESS_VOTERS_CARD = 'likeness_voters_card',
	LIKENESS_DRIVERS_LICENSE = 'likeness_drivers_license',
	AML_DOCUMENT = 'aml_document',
	AML_CHECK = 'aml_check',
	ADDRESS_VERIFICATION = 'address_verification',
	ADDRESS_VERIFICATION_MINI = 'address_verification_mini',
	BUSINESS_ADDRESS_VERIFICATION = 'business_address_verification',
	BUSINESS_ADDRESS_VERIFICATION_MINI = 'business_address_verification_mini',
	MARKET_PLACE_ADDRESS_VERIFICATION = 'market_place_address_verification',
	MARKET_PLACE_ADDRESS_VERIFICATION_MINI = 'market_place_address_verification_mini',
	CAC_PREMIUM_EXPANDED = 'cac_premium_expanded',
	CAC_PREMIUM = 'cac_premium',
	CAC_MINI = 'cac_mini',
	CAC_MINI_TIN = 'cac_mini_tin',
	CAC_MINI_WITH_TIN = 'cac_mini_with_tin',
	TIN = 'tin',
	TIN_MINI = 'tin_mini',
	STATEMENT = 'statement',
	NUBAN = 'nuban',
	NUBAN_BVN = 'nuban_bvn',
	EMPLOYMENT = 'employment',
	GUARANTOR = 'guarantor',
}

export enum ApiEnvironmentEnum {
	PRODUCTION = 'production',
	SANDBOX = 'sandbox',
	DEVELOPMENT = 'development',
}

export enum FrequencyEnum {
	DAILY = 'daily',
	WEEKLY = 'weekly',
	MONTHLY = 'monthly',
	QUARTERLY = 'quarterly',
	ANNUALLY = 'annually',
	NEVER = 'never',
}

export enum GenderEnum {
	MALE = 'male',
	FEMALE = 'female',
}

export enum GeneralStatusEnum {
	PENDING = 'pending',
	USED = 'used',
	EXPIRED = 'expired',
}

export enum IdTypeEnumForSearchEnum {
	PROJECT = 'project',
	PRODUCT = 'product',
	COMPANY = 'company',
	PLAN = 'plan',
	CUSTOMER_PLAN = 'customer_plan',
	USER = 'user',
	WALLET = 'wallet',
	CURRENCY = 'currency',
	CUSTOMER = 'customer',
	ROLE = 'role',
}

export enum InvoiceStatusEnum {
	UNPAID = 'unpaid',
	OVERDUE = 'overdue',
	PAID = 'paid',
	REIMBURSED = 'reimbursed',
}

export enum LivenessActionsEnum {
	FACE_ROTATION = 'face_rotation',
	OPEN_MOUTH = 'open_mouth',
	ZOOM = 'zoom',
	BLINK = 'blink',
	YES_OR_NO = 'yes_or_no',
	MOTION = 'motion',
	NOD = 'nod',
	PASSIVE = 'passive',
}

export enum LivenessThresholdEnum {
	VERY_LOW = 'very_low',
	LOW = 'low',
	MEDIUM = 'medium',
	HIGH = 'high',
	EXTREME = 'extreme',
}

export enum PaymentGatewayEnum {
	BANK_TRANSFER = 'bank-transfer',
	FLUTTERWAVE = 'flutterwave',
	THE_CORE = 'the-core',
	WALLET = 'wallet',
}

export enum TimezoneFormatEnum {
	TWENTY_FOUR = '24',
	TWELVE = '12',
}

export enum TitleEnum {
	MR = 'mr',
	MS = 'ms',
	MRS = 'mrs',
	DR = 'dr',
}

export enum TransactionStatusEnum {
	PENDING = 'pending',
	SUCCESSFUL = 'successful',
	FAILED = 'failed',
	REVERSED = 'reversed',
	UNDER_REVIEW = 'under_review',
}

export enum TransactionTypeEnum {
	CREDIT = 'credit',
	DEBIT = 'debit',
}

export enum VerificationChannelEnum {
	SMS = 'sms',
	EMAIL = 'email',
	WHATSAPP = 'whatsapp',
	SMS_WHATSAPP = 'sms_whatsapp',
}

export enum VerificationTypeEnum {
	RESET = 'reset',
	TFA = '2fa',
	BVN = 'bvn',
	REGISTER = 'register',
}

export enum ErrorResponseEnum {
	TOKEN_NOT_FOUND = 'No authentication token found. Please login again',
	SESSION_EXPIRED = 'Session expired. You have been logged out',
	LOGGED_OUT_DUE_TO_INACTIVITY = 'Logged out due to inactivity',
	INVALID_EMAIL = 'Invalid email address',
	LOGIN_FAILED = 'Login Failed',
	LOGIN_ERROR = 'An error occurred while logging in',
	ERROR_OCCURRED = 'Error Occurred',
	REQUEST_FAILED = 'Request Failed',
}

export enum FormValidationEnum {
	EMAIL_REQUIRED = 'Email is required',
	PASSWORD_REQUIRED = 'Password is required',
	TOKEN_NEEDED = 'Please Enter Authenticator Token Value',
	ACTION_CANNOT_BE_REVERSED = 'This action cannot be reverted',
	SURE = 'Are you sure?',
	SURE_FULL = 'Are you sure you want to perform this action?',
	ENTER_NAME = 'Please enter a name',
	FIELD_REQUIRED = 'This field is required',
	ENTER_EMAIL = 'Enter valid email address',
	ENTER_PHONE = 'Please enter a valid phone number',
	PASSWORD_VALIDATION = 'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
	PASSWORD_MATCH = 'Passwords must match',
	VALID_TOKEN = 'Please enter a valid reset token',
}

export enum SuccessResponseEnum {
	TOKEN_CREATED = 'A new verification token has been sent to your email address',
	TOKEN_SENT = 'Token Sent Successfully',
	UPDATED = 'Updated Successfully',
	CREATED = 'Created Successfully',
	ACCOUNT_CREATED = 'You have successfully created your staff account!',
	PASSWORD_CHANGED = 'You have successfully changed your password',
}

export enum FieldTypeEnum {
	STRING = 'string',
	TELEPHONE = 'telephone',
	DATE = 'date',
	SET = 'set',
	FILE = 'file',
	NUMBER = 'number',
}
